import { Object3D } from 'three';
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader.js';

import { useLoader } from '@react-three/fiber';
import { GLTFLoader } from '@spazious/dollhouse-loaders';
import { isMesh } from '@spazious/dollhouse-three';

import { useDollhouse } from '../components/Dollhouse/index.js';

export { GLTFLoader } from '@spazious/dollhouse-loaders';
export type { GLTF };

/**
 * Loads a GLTF model and returns it.
 */

export const useModelLoader = <U extends string | string[]>(
  input: U
): U extends string[] ? GLTF[] : GLTF => {
  const { gl } = useDollhouse();

  const gltf = useLoader(GLTFLoader, input, (loader) => {
    if (gl) {
      loader.detectSupport(gl);
    }
  }) as any;

  // Logic inhereted from useModelLoader
  ((Array.isArray(gltf) ? gltf : [gltf]) as GLTF[]).forEach(({ scene }) => {
    const itemsToRemove: Object3D[] = [];

    scene.traverse((child) => {
      if (isMesh(child)) {
        child.castShadow = true;
        child.receiveShadow = false;

        // Considered as shadow catcher
        if (/shadow|plane/i.test(child.name)) {
          itemsToRemove.push(child);
        }
      }
    });

    itemsToRemove.forEach((item) => item.parent?.remove(item));
  });

  return gltf;
};

export default useModelLoader;
